import React from "react";
import ConfiguracaoService from "../../services/ConfiguracaoService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaConfiguracao extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: ConfiguracaoService,
            labels: {
                title: 'Lista de Configuração(es)',
                btnNewRegister: 'Configuração',
            },
            keyItem: 'idConfiguracao',
            urlForm: '/CadConfiguracao',
            itensFilter: ["idConfiguracao", "chave", "valor"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-4"> Chave </th>
                <th className="col-md-6 d-none d-md-table-cell"> Valor </th>                
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idConfiguracao}</td>
                <td>{item.chave}</td>
                <td className="d-none d-md-table-cell">{item.valor}</td>
            </>);
    }

    render() {
        return super.render();
    }
}